import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { store }  from './store/index.js'
import { defineCustomElements, addTheme } from 'corporate-ui'
import { theme as scania } from 'scania-theme'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas, faHeart } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { msalInstance } from "./adAuth-config.js"
import { msalPlugin } from "@/plugins/msalPlugin.js"
import { EventType } from "@azure/msal-browser"

library.add(fas, fab, faHeart) // Add both solid and brands icons
addTheme(scania)
defineCustomElements()
const app = createApp(App)

// Account selection logic is app dependent. Adjust as needed for different use cases.
var accounts = msalInstance.getAllAccounts()
if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0])
}

msalInstance.addEventCallback(function (event) {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        var payload = event.payload
        var account = payload.account
        msalInstance.setActiveAccount(account)
    }
})

app.component("FontAwesomeIcon", FontAwesomeIcon)

app.config.warnHandler = () => null

app.use(store)
app.use(router)
app.use(msalPlugin, msalInstance)
app.mount("#app")
